import { TaskStatusLabel } from "@/constants/Tasks";
import { TasksTestID } from "@/constants/TestID";
import { FAIconName, Icon, Text } from "@/ui/core";
import { BaseCard, Box, HStack, StandardCardWidth, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface TaskOverviewCardProps {
  duration: string;
  onPress?: () => void;
  patientName?: string;
  taskId: string;
  taskStatus: string;
  taskTitle: string;
}

const TaskOverviewCard = ({
  duration,
  onPress,
  patientName,
  taskId,
  taskStatus,
  taskTitle,
}: TaskOverviewCardProps) => {
  const baseTestID = joinTestIDs(TasksTestID.TaskOverview, taskId);

  return (
    <BaseCard
      maxWidth={StandardCardWidth}
      onPress={onPress}
      testID={baseTestID}
    >
      <VStack gap={8} height={87}>
        <Box flex={1}>
          <Text
            accessibilityLabel={taskTitle}
            numberOfLines={2}
            testID={joinTestIDs(baseTestID, "title")}
            variant="bodyMedium"
          >
            {taskTitle}
          </Text>
        </Box>
        <VStack gap={4}>
          {patientName && (
            <HStack alignItems="center" gap={6}>
              <Icon
                color={ColorToken.NeutralSecondary}
                name={FAIconName.User}
                size="sm"
                testID={joinTestIDs(baseTestID, "patient")}
              />
              <Text
                accessibilityLabel={`For ${patientName}`}
                color={ColorToken.NeutralSecondary}
                testID={joinTestIDs(baseTestID, "patient-name")}
                variant="caption"
              >
                For {patientName}
              </Text>
            </HStack>
          )}
          <HStack alignItems="center" gap={6}>
            <Icon
              color={ColorToken.NeutralSecondary}
              name={
                taskStatus === TaskStatusLabel.InProgress
                  ? FAIconName.Pen
                  : FAIconName.Clock
              }
              size="sm"
              testID={joinTestIDs(baseTestID, "duration")}
            />
            <Text
              accessibilityLabel={`Estimated duration: ${duration}`}
              color={ColorToken.NeutralSecondary}
              testID={joinTestIDs(baseTestID, "duration")}
              variant="caption"
            >
              {taskStatus === TaskStatusLabel.InProgress
                ? "In progress"
                : duration}
            </Text>
          </HStack>
        </VStack>
      </VStack>
    </BaseCard>
  );
};

export default TaskOverviewCard;
export type { TaskOverviewCardProps };
